module.exports = __webpack_public_path__ + "static/img/banner@3x.d557c441.jpg";